<template>
  <div class="py-3 container-fluid">

    <!-- Filtros -->
    <div class="bg-white rounded-xl shadow-md p-3 space-y-2">
      <h3 class="text-base font-bold text-gray-600 mb-3">{{ $t('label.filtros') }}</h3>

      <div class="w-full flex flex-col lg:flex-row gap-2">        
        <Field v-if="configuracionMeeting.tipoVistaSolicitudes == VISTA_MEETING_EMPRESA" name="filtroPais" v-slot="{ handleChange, handleBlur, value, errors }" v-model="filtroPais">
          <Select @blur="handleBlur" filter @update:model-value="val => { handleChange(val);  filtroPais = val; filtrar(); }" show-clear :model-value="value" :placeholder="$t('label.pais')" class="input-base" :options="paises" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
        </Field>
        <Field v-if="configuracionMeeting.tipoVistaSolicitudes == VISTA_MEETING_ACREDITADO" name="filtroTipoAcreditado" v-slot="{ handleChange, handleBlur, value, errors }" v-model="filtroTipoAcreditado">
          <Select @blur="handleBlur" filter @update:model-value="val => { handleChange(val);  filtroTipoAcreditado = val; filtrar(); }" show-clear :model-value="value" :placeholder="$t('label.tipo.acreditado')" class="input-base" :options="tiposAcreditados" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
        </Field>
        <InputText @keyup="filtrar" v-model="filtroTexto" :placeholder="$t('label.buscar')" class="input-base" />
      </div>
      <div class="w-full flex flex-col">
        <div v-if="tags">
          <div class="flex flex-wrap -mx-1">
            <div v-for="tag in tags" :key="tag.id" class="w-full md:w-1/2 lg:w-1/4 px-1 pb-2">
              <Field :name="`tag-${tag.id}`">
                <MultiSelect :model-value="tag.opcionesTagSeleccionados" show-clear
                  @update:model-value="val => { tag.opcionesTagSeleccionados = val; filtrar(); }" :options="tag.opciones"
                  optionLabel="descripcion" optionValue="id" filter :placeholder="tag.descripcion" class="input-base" />
              </Field>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full flex flex-col lg:flex-row gap-1 pb-4 text-center">
        <a @click="limpiarFiltros" class="cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-2 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-[102%] active:scale-95">
          <font-awesome-icon :icon="['fas', 'fa-trash']" /> {{ $t('boton.limpiar.filtros') }}
        </a>
      </div>

    </div>
    <!-- Fin Filtros -->

    <div class="bg-transparent p-0">

      <div class="w-full flex flex-col">

        <DataView :value="itemsMeetingFiltrados" paginator :rows="20" :alwaysShowPaginator="false"
          dataKey="item.id" class="!bg-transparent">
          <template #empty>
            <div
              class="w-full flex flex-row items-center justify-center px-5 py-5 text-2xl font-semibold text-center text-gray-500">
              {{ $t('label.no.hay.datos') }}
            </div>
          </template>
          <template #list="slotProps">

            <div class="flex flex-wrap flex-1 -mx-1 mt-3">
              <div v-for="(item, index) in slotProps.items" :key="index" class="w-full p-1.5 md:w-6/12 lg:w-3/12 flex flex-col">
                <ItemEmpresaView v-if="item.tipo == VISTA_MEETING_EMPRESA" :itemMeeting="item" :onSolicitarReunion="onSolicitarReunion" :permiteSolicitarReuniones="permiteSolicitarReuniones" />
                <ItemAcreditadoView v-if="item.tipo == VISTA_MEETING_ACREDITADO" :itemMeeting="item" :onSolicitarReunion="onSolicitarReunion" :permiteSolicitarReuniones="permiteSolicitarReuniones" />
              </div>
            </div>

          </template>
        </DataView>
      </div>

    </div>
  </div>

  <FullScreenLoader :visible="isSubmitting" />
  <PedirCitaView v-if="pedirCitaVisible" :closeFunction="closeDialogPedirCita" :itemMeetingSeleccionado="itemMeetingSeleccionado" />

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Field } from 'vee-validate';
import { formatDate } from '@/utils/formatters';
import Swal from 'sweetalert2'

import DataView from 'primevue/dataview';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import MultiSelect from 'primevue/multiselect';
import FullScreenLoader from '@/components/commons/FullScreenLoader.vue';

import PedirCitaView from './modal/PedirCitaView.vue';

import { TAG_TIPO_EMPRESA, VISTA_MEETING_ACREDITADO, VISTA_MEETING_EMPRESA } from 'qreventos-suite/constantes';
import { TipoAcreditado, Pais, ConfiguracionMeeting, Acreditado, Evento, Tag, ItemMeeting } from 'qreventos-suite/src/services/suite.interfaces';

import meetingService from 'qreventos-suite/meeting';
import configuracionMeetingService, { ConfiguracionMeetingService } from '@/services/configuracion.merting.services';
import generalService from 'qreventos-suite/generales';
import empresaService from 'qreventos-suite/empresas';
import seguridadServices from '@/services/seguridad.services';
import ItemEmpresaView from './items/ItemEmpresaView.vue';
import ItemAcreditadoView from './items/ItemAcreditadoView.vue';

export default defineComponent({
  components: {
    DataView, InputText,
    FullScreenLoader, Field, Select, MultiSelect,
    PedirCitaView, ItemEmpresaView, ItemAcreditadoView
  },
  data() {
    return {
      VISTA_MEETING_ACREDITADO,
      VISTA_MEETING_EMPRESA,
      isSubmitting: false,
      configuracionMeeting: {} as ConfiguracionMeeting,
      acreditado: undefined as unknown as Acreditado,
      itemsMeeting: [] as ItemMeeting[],
      itemsMeetingFiltrados: [] as ItemMeeting[],
      filtroTexto: '',
      filtroTipoAcreditado: undefined as unknown as TipoAcreditado,
      filtroPais: undefined as unknown as Pais,
      tiposAcreditados: [] as TipoAcreditado[],
      paises: [] as Pais[],
      permiteSolicitarReuniones: false,
      pedirCitaVisible: false,
      itemMeetingSeleccionado: undefined as unknown as ItemMeeting,
      tags: [] as Tag[],
    };
  },
  methods: {
    formatDate,
    async fillAcreditado(evento: Evento, hash: string) {
      this.acreditado = await meetingService.findAcreditadoMeetingBy(evento.id, hash);
    },
    async limpiarFiltros() {
      this.filtroTexto = '';
      this.tags.forEach(tag => {
        tag.opcionesTagSeleccionados = [];
      });
      this.filtroPais = undefined as unknown as Pais;
      this.filtroTipoAcreditado = undefined as unknown as TipoAcreditado;
      this.itemsMeetingFiltrados = this.itemsMeeting;
    },
    async filtrarEmpresas() {
      if (!this.filtroPais && this.filtroTexto === '' && this.tags.every(tag => !tag.opcionesTagSeleccionados?.length)) {
        this.limpiarFiltros();
        return;
      }

      this.itemsMeetingFiltrados = this.itemsMeeting.filter(itemMeeting => {
        let paisOk: boolean = false;
        if (this.filtroPais) {
          if (itemMeeting.empresa?.pais.id == this.filtroPais.id) {
            paisOk = true;
          }
        } else {
          paisOk = true;
        }

        let textoOk = itemMeeting.empresa.nombreFantasia?.toLowerCase().includes(this.filtroTexto.toLowerCase());
        if (this.filtroTexto === '') {
          textoOk = true;
        }

        const coincideTags = this.tags.every(tag => {
          if (!tag.opcionesTagSeleccionados?.length) {
            return true;
          } 
          return itemMeeting.empresa.empresaTags?.some(empresaTag => empresaTag.tag.id === tag.id && tag.opcionesTagSeleccionados.includes(empresaTag.tagOpcion.id));
        });
        
        return paisOk && textoOk && coincideTags;
      });      
    },
    async filtrarAcreditados() {
      if (!this.filtroTipoAcreditado && this.filtroTexto === '' && this.tags.every(tag => !tag.opcionesTagSeleccionados?.length)) {
        this.limpiarFiltros();
        return;
      }

      this.itemsMeetingFiltrados = this.itemsMeeting.filter(itemMeeting => {
        let tipoAcreditadoOk: boolean = false;
        if (this.filtroTipoAcreditado) {
          if (itemMeeting.acreditado.tipoAcreditado.id == this.filtroTipoAcreditado.id) {
            tipoAcreditadoOk = true;
          }
        } else {
          tipoAcreditadoOk = true;
        }

        let textoOk = itemMeeting.acreditado.nombre?.toLowerCase().includes(this.filtroTexto.toLowerCase()) || itemMeeting.acreditado.apellido?.toLowerCase().includes(this.filtroTexto.toLowerCase());
        if (this.filtroTexto === '') {
          textoOk = true;
        }        
        
        return tipoAcreditadoOk && textoOk;
      });      
    },
    async filtrar() {
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

      if (configuracionMeeting.tipoVistaSolicitudes == VISTA_MEETING_EMPRESA) {
        await this.filtrarEmpresas();
      } else {
        await this.filtrarAcreditados();
      }
    },
    async fillItemsMeeting() {
      const hash: string = seguridadServices.getLocalHash() as string;
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
      this.itemsMeeting = await meetingService.findItemsMeetingBy(configuracionMeeting.evento.id, hash);
      this.itemsMeetingFiltrados = this.itemsMeeting;
    },
    /**
     * Gestión modal pedir cita
     */
    closeDialogPedirCita(ok: boolean = false) {
      this.pedirCitaVisible = false;
      if (ok) {
        Swal.fire({ title: this.$t('global.atencion'), text: this.$t('label.cita.solicitada.con.exito'), icon: "success" });
      }
    },
    onSolicitarReunion(itemMeeting: ItemMeeting) {
      this.isSubmitting = true;

      try {
        this.configuracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
        if (this.configuracionMeeting.restriccionFechas) {
          const hoy = new Date();

          if (hoy < this.configuracionMeeting.fechaSolicitudDesde || hoy > this.configuracionMeeting.fechaSolicitudHasta) {
            const message:string = this.$t('label.restriccion.fechas', {
              fechaDesde: formatDate(this.configuracionMeeting.fechaSolicitudDesde, 'dd/MM/yyyy HH:mm'),
              fechaHasta: formatDate(this.configuracionMeeting.fechaSolicitudHasta, 'dd/MM/yyyy HH:mm')
            });
            Swal.fire({ title: this.$t('global.atencion'), html: message, icon: "warning" });
            return;
          }
        }

        if (itemMeeting.tipo == VISTA_MEETING_EMPRESA && itemMeeting.cantidadAcreditados == 0) {
          Swal.fire({ title: this.$t('global.atencion'), html: this.$t('label.sin.contactos'), icon: "warning" });
          return;
        }

        this.itemMeetingSeleccionado = itemMeeting;
        this.pedirCitaVisible = true;

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: 'Error ' + error, icon: "error" }).then(() => {
          window.location.reload();
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    /**
     * Fin gestión modal Pedir Cita
     */
    async reDownloadConfiguracionMeeting() {
      this.configuracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

      this.configuracionMeeting = await meetingService.findByContext(this.configuracionMeeting.contextUrl);
      if (this.configuracionMeeting) {
        configuracionMeetingService.save(this.configuracionMeeting);
      }
    },
  },
  async mounted() {
    try {
      const hash: string = seguridadServices.getLocalHash() as string;
      this.isSubmitting = true;
      this.reDownloadConfiguracionMeeting();

      this.paises = await generalService.findPaisesBy();
      this.tiposAcreditados = await meetingService.findTiposAcreditadosSolicitablesBy(this.configuracionMeeting.evento.id, hash);
      await this.fillItemsMeeting();
      await this.fillAcreditado(this.configuracionMeeting.evento, hash);

      this.permiteSolicitarReuniones = this.tiposAcreditados && this.tiposAcreditados.length > 0;

      if (this.configuracionMeeting.tipoVistaSolicitudes == VISTA_MEETING_EMPRESA) {
        this.tags = await empresaService.findTagsBy(this.configuracionMeeting.evento.id, TAG_TIPO_EMPRESA);
      }

      this.limpiarFiltros();

    } catch (error) {
      this.isSubmitting = false;
      Swal.fire({ title: "Error", text: error + '', icon: "error" });
    } finally {
      this.isSubmitting = false;
    }
  }
});
</script>

